import { useEffect } from 'react'

import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { Props as ThrProps } from 'components/pages/healthTools/thr'
import { Props as ThrResultProps } from 'components/pages/healthTools/thr-result'

import { addResultToLink } from './helpers'

const THRToolResultPageComponent = dynamic<ThrResultProps>(
  () => import('components/pages/healthTools/thr-result'),
)

const THRToolPageComponent = dynamic<ThrProps>(
  () => import('components/pages/healthTools/thr'),
)

export type InputError = {
  age: string
  weight: string
  height: string
}

export type ToolPageType = 'form' | 'result'

export type Props = ThrProps | ThrResultProps

export const THRToolPage = (props: Props) => {
  const { type = 'form' } = props
  const router = useRouter()
  useEffect(() => {
    if (type === 'result' || type === 'records') {
      if (!router.asPath.includes('?result=1')) {
        const newPath = addResultToLink(router.asPath)
        router.push(newPath, newPath, { shallow: true })
      }
    }
  }, [type])
  if (type === 'result') {
    return <THRToolResultPageComponent {...(props as ThrResultProps)} />
  } else {
    return <THRToolPageComponent {...(props as ThrProps)} />
  }
}
